"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function updatValueInPlace({ values, newValue, index, }) {
    if (lodash_1.isArray(values)) {
        return Object.assign([...values], { [index]: newValue });
    }
    return [newValue];
}
exports.default = updatValueInPlace;
